import { IMiddlewareEvent } from 'mobx-state-tree';
import { Query } from 'mst-gql';
import { ClientError } from 'graphql-request';
import getAppEnv from '../utils/getAppEnv';
import { rateLimitNotification } from '../../../notifications/rateLimit';

const HTTP_TOO_MANY_REQUESTS = 429;
const MSTGQL_ACTIONS = ['query', 'mutate'];

const isMstGqlAction = (call: IMiddlewareEvent) => (
  call.type === 'action' && MSTGQL_ACTIONS.indexOf(call.name) > -1
);

const isRateLimitError = (error: unknown): boolean => {
  return error instanceof ClientError && error.response?.status === HTTP_TOO_MANY_REQUESTS;
};

// Listens to mst-gql request actions and notifies user when rate limited (429)
export default (call: IMiddlewareEvent, next: (actionCall: IMiddlewareEvent, callback?: (value: any) => any) => void) => {
  if (isMstGqlAction(call)) {
    return next(call, (value: any) => {
      if (value instanceof Query) {
        value.currentPromise().catch((error: unknown) => {
          if (isRateLimitError(error)) {
            getAppEnv(call.tree).notification(rateLimitNotification());
          }
        });
      }

      return value;
    });
  }

  return next(call);
};
